module.exports = __webpack_public_path__ + "static/img/wanted4.369874f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/wanted4.png
// module id = wPpK
// module chunks = 1 3